var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.error && _vm.errors)?_c('div',{attrs:{"id":"error-messages"}},_vm._l((_vm.errors),function(err){return _c('b-alert',{key:err.code,attrs:{"variant":"danger","show":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getErrorMessageHtml(err))}})])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }